import { SpaceQuantityUnit } from "@project-rouge/rg-core";
function getRequiredQuantity(space, buildingAttributes) {
	let quantity = 0;
	if (space.attributes.quantity && space.attributes.quantityUnit) switch (space.attributes.quantityUnit) {
		case SpaceQuantityUnit.Building:
			quantity += space.attributes.quantity;
			break;
		case SpaceQuantityUnit.Core:
			quantity += buildingAttributes.CoreShafts * space.attributes.quantity;
			break;
		case SpaceQuantityUnit.Level:
			quantity += buildingAttributes.Levels * space.attributes.quantity;
			break;
		case SpaceQuantityUnit.UnitsTotal:
			quantity += buildingAttributes.Units * space.attributes.quantity;
			break;
		default:
			if (space.attributes.quantityUnit.includes("Units")) quantity += buildingAttributes[space.attributes.quantityUnit] * space.attributes.quantity;
			else throw new Error(`Quantity unit '${space.attributes.quantityUnit}' has not been implemented yet.`);
			break;
	}
	else if (space.consolidationType) return 1;
	else return -1;
	return quantity;
}
export { getRequiredQuantity };

//# sourceMappingURL=index96.js.map